import { useReducer } from "react";

import { ManagementCompany } from "./types";

export const initial: State = {
	data: [],
	nullCifOnly: false,
	term: "",
	totalItems: 0
};

export interface State {
	data: ManagementCompany[];
	nullCifOnly: boolean;
	term: string;
	totalItems: number;
}

enum ActionType {
	setData = "setData",
	onChangeNullCifOnly = "onChangeNullCifOnly",
	onChangeTerm = "onChangeTerm",
	setTotalItems = "setTotalItems"
}

interface Action {
	type: string;
	val: ManagementCompany[] | boolean | string | number;
}

function reducer(state: State, action: Action): State {
	switch (action.type) {
		case ActionType.setData:
			return {
				...state,
				data: action.val as ManagementCompany[]
			};
		case ActionType.onChangeNullCifOnly:
			return {
				...state,
				nullCifOnly: action.val as boolean
			};
		case ActionType.onChangeTerm:
			return {
				...state,
				term: action.val as string
			};
		case ActionType.setTotalItems:
			return {
				...state,
				totalItems: action.val as number
			};

		default:
			throw new Error();
	}
}

export default function useManagentCompaniesStore() {
	const [state, dispatch] = useReducer(reducer, initial);

	const actions = {
		setData: (data: ManagementCompany[]) => dispatch({ type: ActionType.setData, val: data }),
		onChangeNullCifOnly: (nullCifOnly: boolean) =>
			dispatch({ type: ActionType.onChangeNullCifOnly, val: nullCifOnly }),
		onChangeTerm: (term: string) => dispatch({ type: ActionType.onChangeTerm, val: term }),
		setTotalItems: (totalItems: number) =>
			dispatch({ type: ActionType.setTotalItems, val: totalItems })
	};

	return [state, actions] as const;
}
